'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdHotTub = function MdHotTub(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.5 9.8c1.7 1.6 2.4 3.9 2.1 6.1l-0.1 0.7h-3.2l0.2-0.9c0.3-1.3-0.2-2.8-1.2-3.7-1.7-1.8-2.5-4-2.2-6.3l0.1-0.7h3.2l-0.2 1c-0.2 1.3 0.2 2.7 1.1 3.7z m6.6 0c1.7 1.6 2.5 3.9 2.2 6.1l-0.2 0.7h-3.1l0.2-0.9c0.2-1.3-0.2-2.7-1.1-3.7l-0.2 0c-1.7-1.8-2.5-4-2.2-6.3l0.2-0.7h3.1l-0.2 1c-0.2 1.3 0.2 2.7 1.1 3.7z m0.5 23.6v-10h-3.2v10h3.2z m-6.6 0v-10h-3.4v10h3.4z m-6.6 0v-10h-3.4v10h3.4z m-6.8 0v-10h-3.2v10h3.2z m7-13.4h18v13.4c0 1.8-1.4 3.2-3.2 3.2h-26.8c-1.8 0-3.2-1.4-3.2-3.2v-13.4h5v-1.2c0-2.1 1.7-3.8 3.7-3.8 1.2 0 2.2 0.6 2.8 1.3l2.3 2.5c0.4 0.5 0.8 0.8 1.4 1.2z m-10.2-10c0-1.9 1.4-3.4 3.2-3.4s3.4 1.5 3.4 3.4-1.5 3.4-3.4 3.4-3.2-1.5-3.2-3.4z' })
        )
    );
};

exports.default = MdHotTub;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/hot-tub.js
// module id = 2423
// module chunks = 0